import axios from "axios";
import { firebaseAuth } from "../config/firebase";

const API_BASE_URL =
  import.meta.env.VITE_BASE_URL_API_BACKEND ||
  import.meta.env.VITE_API_BASE_URL ||
  "http://localhost:4000/api/v1";

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const clearSessionAndRedirect = () => {
  localStorage.removeItem("auth_token");
  localStorage.removeItem("tenant_id");
  if (!window.location.pathname.includes("/login")) {
    window.location.href = "/login";
  }
};

// Obtém um token sempre fresco — o SDK do Firebase renova automaticamente
// quando está próximo do vencimento (sem chamada de rede quando ainda válido).
const attachAuthAndTenantHeaders = async (config) => {
  const user = firebaseAuth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken();
      localStorage.setItem("auth_token", token);
      config.headers.Authorization = `Bearer ${token}`;
    } catch {
      clearSessionAndRedirect();
      return Promise.reject(new Error("Sessão expirada. Faça login novamente."));
    }
  } else {
    // Sem usuário Firebase — remove token obsoleto do localStorage
    const token = localStorage.getItem("auth_token");
    if (token) {
      clearSessionAndRedirect();
      return Promise.reject(new Error("Sessão expirada. Faça login novamente."));
    }
  }
  const tenantId = localStorage.getItem("tenant_id");
  if (tenantId) config.headers["X-Tenant-Id"] = tenantId;
  return config;
};

const handleResponseError = (error) => {
  if (error.response?.status === 401) {
    clearSessionAndRedirect();
  }
  const message =
    error.response?.data?.message ||
    error.response?.data?.error ||
    error.message ||
    "Erro de comunicação com o servidor";
  return Promise.reject(new Error(message));
};

api.interceptors.request.use(
  (config) => attachAuthAndTenantHeaders(config),
  (error) => Promise.reject(error),
);

axios.interceptors.request.use(
  (config) => attachAuthAndTenantHeaders(config),
  (error) => Promise.reject(error),
);

api.interceptors.response.use((response) => response, handleResponseError);
axios.interceptors.response.use((response) => response, handleResponseError);
